import { get, post } from './request'
import { getStore, keys } from '../store'
/**
 *
 * @param {String} mobile
 * @param {String} password
 * @param {String} country_code
 * @returns {Promise<
 *  {
 *      token: String
 *      country_code: String
 *      email: String
 *      invite_code: String
 *      last_student_avatar: String
 *      last_student_nickname: String
 *      last_student_sn: String
 *      mobile: String
 *      nickname: String
 *      referer_code: String
 *      status: Number
 *      token: String
 *      user_sn: String
 * }>}
 */
export function login(mobile, password, country_code) {
    return post('/api/login', { mobile, password, country_code })
}

/**
 *
 * @returns {Promise<Array<{ kinds:Number }>>}
 */
export function getKidsTypeList() {
    return get('/api/getKidsTypeList')
}

/**
 * @param  {Number} kids 孩子的数量
 * @returns {Promise<{
 *      "kid_type": Number,
 *      "title": String,
 *      "remarks": String,
 *      "describe": String",
 *      "price": String,
 *      "discount": null,
 *      "plan_details": String[],
 *      "color": String
 * }>}
 */
export function getPlanList(kids,user_sn) {
    return get(`/api/getPlanList?kids=${kids}&user_sn=${user_sn}`)
}

/**
 *
 * @returns {Promise<{
 *      price: String
 *      quantity: Number
 * }>}
 */
export function getCreatPlanList(user_sn) {
    return get(`/api/getCreatPlanList?user_sn=${user_sn}`)
}

/**
 *
 * @returns {Promise<{
 *      title: String
 *      content: String
 * }>}
 */
export function getFaqList() {
    return get('/api/getFqaList')
}

/**
 *
 * @returns
 */
export function getUserInfo() {
    return get('/api/getUserInfo')
}
/**
 *
 */
export function getHidePlanList(){
    return get('/api/getHidePlanList')
}
/**
 *
 */
export function getMyPlanList() {
    return get('/api/getMyPlanList')
}

export function getBillingHistoryList(pageIndex, pageSize = '') {
    return get(`/api/getBillingHistoryList?page=${pageIndex}&pagesize=${pageSize}`)
}

export function getChargesList(pageIndex, pageSize = '') {
    return get(`/api/getChargesList?page=${pageIndex}&pagesize=${pageSize}`)
}

/**
 *
 * @param {string} plan_id
 * @returns
 */
export function buyMember(plan_id) {
    return post('/api/buyMember', { plan_id })
}

/**
 *
 * @param {string} good_id
 * @returns
 */
export function buyCredit(good_id) {
    return post('/api/buyCredit', { good_id })
}

/**
 *
 * @param {{
 * order_no: String
 * username: String
 * mobile: String
 * email: String
 * pay_method: String
 * }} data
 * @returns {}
 */
export function confirmOrder(data) {
    return post('/api/confirmOrder', data)
}

/**
 *
 * @param {{
 * order_no: String
 * payment_method_nonce: String
 * }} data
 * @returns {}
 */
export function creatBrainTreeOrder(data) {
    return post('/api/creatBrainTreeOrder', data)
}

/**
 *
 * @param {String} order_no 订单号
 * @param {String} type
 * @returns {Promise<{
 *      sessionId: String,
 *      url:String
 *  }>
 * }
 */
export function stripePayment(order_no, type) {
    return post('/api/stripePayment', { order_no, type })
}

/**
 * 发送验证码
 * @param {*} mobile
 * @param {*} country_code
 * @returns
 */
export function verifyCode(mobile, country_code) {
    return post('/api/login/verify-code', { mobile, country_code, length: 6 })
}
/**
 * 检测手机号
 * @param {*} mobile
 * @param {*} country_code
 * @returns
 */
 export function checkUser(mobile, country_code) {
    return post('/api/checkUser', { mobile, country_code})
}
/**
 * 短信验证码登录
 * @param {*} mobile
 * @param {*} verifyCode
 * @param {*} country_code
 * @returns {{
 *  id:String
 *  user_sn:String
 *  model:String
 *  first_name:String
 *  last_name:String
 *  name:String
 *  nickname:String
 *  mobile:String
 *  email:String
 *  gender:String
 *  avatar:String
 *  motto:String
 *  open_id:String
 *  unique_id:String
 *  last_login_time:String
 *  created_at:String
 *  updated_at:String
 *  stopped_at:String
 *  country_code:String
 *  province:String
 *  city:String
 *  district:String
 *  invite_code:String
 *  token:String
 *  last_student_sn:String
 *  last_student_nickname:String
 *  last_student_avatar:String
 *  is_register:String  true:新用户注册 false:老用户
 * }}
 */
export function verifyCodeLogin(mobile, verifyCode, country_code,time_zone) {
    return post('/api/verify-code-login', { mobile, code: verifyCode, country_code,time_zone })
}
/**
 * 账号密码登录
 * @param {*} mobile
 * @param {*} password
 * @param {*} country_code
 * @returns {{
 *  is_register:String  true:新用户注册 false:老用户
 * }}
 */
export function passLogin(mobile, password, country_code,time_zone) {
    return post('/api/login', { mobile, password, country_code,time_zone })
}

/**
 *
 * @param {*} full_name 姓名
 * @param {*} email 邮箱
 * @param {*} wechat_id 微信号
 * @returns
 */
export function setUserProfile(full_name, email, wechat_id) {
    return post('/api/setUserProfile', { full_name, email, wechat_id })
}

/**
 * 选择国家或地区
 */
export function getCountries({ page = 1, pageSize = 999, keywords = null, country_code = null }) {
    return get('/api/dict/countries', { page, pageSize, keywords, country_code })
}

/**
 * 点击记录
 * @param {*} type 1 进入首页  2 注册成功  3 订单页
 * @param {*} user_sn 用户sn
 */
export function recordClick(type, user_sn, value) {
    return post('/api/addCheckPointsLog', { type, user_sn, value })
}

/**
 *
 * @param {String} mobile
 * @param {String} name
 * @param {String} country_code
 * @param {String} email
 * @returns {Promise<
*  {
    *      country_code: String
    *      email: String
    *      mobile: String
    *      name: String
    *      wechat_id: String
    * }>}
*/
export function joinUser(form) {
    return post('/api/signUpUser',form)
}
/**
 *
 */
 export function getPayOrderDetail() {
    return get('/api/getPayOrderDetail')
}

export function getIntercomUser(time_zone) {
    return get(`/api/intercomUser?time_zone=${time_zone}`)
}
/**
 * 获取销售卡片信息
 */
 export function getSaleInfo(invite_code) {
    return get('/api/getSaleInfo?invite_code='+invite_code)
}
/**
 * 获取图片验证码
 */
 export function getImgCode() {
    return get('/api/getImgCode')
}



// WEBPACK FOOTER //
// ./src/api/index.js